/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseBatchResource
 */
export interface ExpenseBatchResource {
    /**
     * 
     * @type {string}
     * @memberof ExpenseBatchResource
     */
    expenseBatchId: string;
}

/**
 * Check if a given object implements the ExpenseBatchResource interface.
 */
export function instanceOfExpenseBatchResource(value: object): value is ExpenseBatchResource {
    if (!('expenseBatchId' in value) || value['expenseBatchId'] === undefined) return false;
    return true;
}

export function ExpenseBatchResourceFromJSON(json: any): ExpenseBatchResource {
    return ExpenseBatchResourceFromJSONTyped(json, false);
}

export function ExpenseBatchResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseBatchResource {
    if (json == null) {
        return json;
    }
    return {
        
        'expenseBatchId': json['expenseBatchId'],
    };
}

export function ExpenseBatchResourceToJSON(value?: ExpenseBatchResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expenseBatchId': value['expenseBatchId'],
    };
}

